// eslint-disable-next-line disable-autofix/import/no-namespace
import * as icons from "./../MathEquationEditor/equation-icons";
import React from "react";

export const MathEquationMenu = {
  teacherPortalIBPYPRootNodes: ["MAIN", "ABC", "FUNC"],

  nodes: [
    {
      id: "MAIN",
      label: "Main",
      children: [
        [
          "i_inv",
          "sup",
          "absolute",
          "nthroot",
          "square_root",
          "pi",
          "sine",
          "cos",
          "tan",
          "open_parenthesis",
          "close_parenthesis",
          "comma",
        ],
        [
          "7",
          "8",
          "9",
          "divide",
          "4",
          "5",
          "6",
          "multiply",
          "1",
          "2",
          "3",
          "minus",
          "0",
          "decimal",
          "ans",
          "plus",
        ],
        [
          "percent",
          "fraction",

          "backward_reaction",
          "forward_reaction",

          "double_bond",
          "backspace",

          "insert",
        ],
      ],
    },

    {
      id: "FUNC",
      label: "Func",
      children: [
        [
          "sine",
          "cos",
          "tan",
          "sin_inverse",
          "cos_inverse",
          "tan_inverse",
          "mean",
          "stdev",
          "factorial",
          "permutation",
          "combination",
          "stdevp",
        ],

        [
          "sup",
          "nthroot",
          "square_root",
          "e^x",
          "abs",
          "round",
          "natural_log",
          "log",
          "backspace",
          "e",
          "pi",
          "insert",
        ],
      ],
    },

    {
      id: "ABC",
      label: "ABC",
      children: [
        ["q", "w", "E", "r", "t", "y", "u", "i", "o", "p"],

        ["a", "s", "d", "f", "g", "h", "j", "k", "l"],

        [
          "comma",
          "z",
          "x",
          "c",
          "v",
          "b",
          "n",
          "m",
          "double_bond",
          "backspace",
        ],

        [
          "shift",
          "open_brace",
          "close_brace",
          "open_square_brace",
          "close_square_brace",

          "langrange_first_derivative",
          "factorial",
          "pi",
          "insert",
        ],
      ],
    },
    {
      id: "headerCtrl",
      label: "headerCtrl",
      children: ["undo", "redo", "AC", "C"],
    },
  ],

  nodeChildren: [
    {
      icon: icons.BackwardReaction,
      id: "backward_reaction",
      onClick: mfe => mfe.executeCommand("moveToPreviousChar"),
      text: "Backward reaction",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.ForwardReaction,
      id: "forward_reaction",
      onClick: mfe => mfe.executeCommand("moveToNextChar"),
      text: "Forward reaction",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Fraction,
      id: "fraction",
      latex: "\\frac{#0}{\\placeholder}",
      text: "Fraction",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.NaturalLogarithm,
      id: "natural_log",
      latex: "\\ln",
      text: "Natural log",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Logarithm,
      id: "log",
      latex: "\\log",
      text: "Log",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Superscript,
      id: "sup",
      latex: "^{\\placeholder}",
      text: "Superscript (^)",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Parentheses,
      id: "open_parenthesis",
      latex: "\\left(#0\\right)",
      text: "Open parenthesis",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Parentheses1,
      id: "close_parenthesis",
      latex: ")",
      text: "Close parenthesis",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Absolute,
      id: "absolute",
      latex: "\\left|\\placeholder{}\\right|",
      text: "Absolute",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.NaturalLogarithmicBase,
      id: "e",
      latex: "\\exponentialE",
      text: "Exponential e",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Pi,
      id: "pi",
      latex: "\\pi",
      shiftIcon: icons.CapitalPi,
      shiftLatex: "\\Pi",
      text: "Pi",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Percent,
      id: "percent",
      latex: "\\%",
      text: "Percent",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.SquareBrackets,
      id: "open_square_brace",
      latex: "\\left[#0\\right]",
      text: "Open square bracket",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.SquareBrackets1,
      id: "close_square_brace",
      latex: "]",
      text: "Close square bracket",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.CurlyBrackets,
      id: "open_brace",
      latex: "\\left\\lbrace#0\\right\\rbrace",
      text: "Open brace",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.CurlyBrackets1,
      id: "close_brace",
      latex: "\\rbrace",
      text: "Close brace",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.SqaureRoot,
      id: "square_root",
      latex: "\\sqrt{\\placeholder}",
      text: "Square root",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.NthRoot,
      id: "nthroot",
      latex: "\\sqrt[#0]{\\placeholder}",
      text: "nth root",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      id: "blank",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Lagrange1StDerivative,
      id: "langrange_first_derivative",
      latex: "{\\placeholder{}}^{\\prime}",
      text: "Langrange first derivative",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Permutations,
      id: "permutation",
      latex:
        "\\operatorname{nPr}\\left(\\placeholder{⬚},\\placeholder{⬚}\\right)",

      text: "Permutation",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Combinations,
      id: "combination",
      latex: "\\operatorname{nCr}(\\placeholder{⬚},\\placeholder{⬚})",

      text: "Combination",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Factorial,
      id: "factorial",
      latex: "!",
      text: "Factorial",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Cos,
      id: "cos",
      latex: "\\cos",
      text: "Cosine",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.SinInverse,
      id: "sin_inverse",
      latex: "\\sin^{-1}\\left(\\placeholder{⬚}\\right)",
      text: "Sin Inverse",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Sin,
      id: "sine",
      latex: "\\sin",
      text: "Sine",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.CosInverse,
      id: "cos_inverse",
      latex: "\\cos^{-1}\\left(\\placeholder{⬚}\\right)",
      text: "Cos Inverse",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Tan,
      id: "tan",
      latex: "\\tan",
      text: "Tan",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.TanInverse,
      id: "tan_inverse",
      latex: "\\tan^{-1}\\left(\\placeholder{⬚}\\right)",
      text: "Tan Inverse",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.ShiftOutlined,
      id: "shift",
      onClick: (mfe, toggleShiftState) => {
        toggleShiftState();
      },
      shiftIcon: icons.ShiftFill,
      text: "Shift Key",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.AlphabetQ,
      id: "q",
      latex: "q",
      shiftIcon: icons.CapitalQ,
      shiftLatex: "Q",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetW,
      id: "w",
      latex: "w",
      shiftIcon: icons.CapitalW,
      shiftLatex: "W",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetE,
      id: "E",
      latex: "e",
      shiftIcon: icons.CapitalE,
      shiftLatex: "E",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetR,
      id: "r",
      latex: "r",
      shiftIcon: icons.CapitalR,
      shiftLatex: "R",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetT,
      id: "t",
      latex: "t",
      shiftIcon: icons.CapitalT,
      shiftLatex: "T",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetY,
      id: "y",
      latex: "y",
      shiftIcon: icons.CapitalY,
      shiftLatex: "Y",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetU,
      id: "u",
      latex: "u",
      shiftIcon: icons.CapitalU,
      shiftLatex: "U",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetI,
      id: "i",
      latex: "i",
      shiftIcon: icons.CapitalI,
      shiftLatex: "I",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetO,
      id: "o",
      latex: "o",
      shiftIcon: icons.CapitalO,
      shiftLatex: "O",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetP,
      id: "p",
      latex: "p",
      shiftIcon: icons.CapitalP,
      shiftLatex: "P",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetA,
      id: "a",
      latex: "a",
      shiftIcon: icons.CapitalA,
      shiftLatex: "A",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetS,
      id: "s",
      latex: "s",
      shiftIcon: icons.CapitalS,
      shiftLatex: "S",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetD,
      id: "d",
      latex: "d",
      shiftIcon: icons.CapitalD,
      shiftLatex: "D",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetF,
      id: "f",
      latex: "f",
      shiftIcon: icons.CapitalF,
      shiftLatex: "F",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetG,
      id: "g",
      latex: "g",
      shiftIcon: icons.CapitalG,
      shiftLatex: "G",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetH,
      id: "h",
      latex: "h",
      shiftIcon: icons.CapitalH,
      shiftLatex: "H",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetJ,
      id: "j",
      latex: "j",
      shiftIcon: icons.CapitalJ,
      shiftLatex: "J",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetK,
      id: "k",
      latex: "k",
      shiftIcon: icons.CapitalK,
      shiftLatex: "K",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetL,
      id: "l",
      latex: "l",
      shiftIcon: icons.CapitalL,
      shiftLatex: "L",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetZ,
      id: "z",
      latex: "z",
      shiftIcon: icons.CapitalZ,
      shiftLatex: "Z",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetX,
      id: "x",
      latex: "x",
      shiftIcon: icons.CapitalX,
      shiftLatex: "X",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetC,
      id: "c",
      latex: "c",
      shiftIcon: icons.CapitalC,
      shiftLatex: "C",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AC,
      id: "AC",
      latex: "AC",
      onClick: mfe => mfe.executeCommand("deleteAll"),
      style: {
        padding: "12px",
      },
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.CapitalC,
      id: "C",
      latex: "C",
      onClick: mfe => mfe.executeCommand("deleteAll"),
      style: {
        padding: "12px",
      },
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetV,
      id: "v",
      latex: "v",
      shiftIcon: icons.CapitalV,
      shiftLatex: "V",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetB,
      id: "b",
      latex: "b",
      shiftIcon: icons.CapitalB,
      shiftLatex: "B",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetN,
      id: "n",
      latex: "n",
      shiftIcon: icons.CapitalN,
      shiftLatex: "N",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.AlphabetM,
      id: "m",
      latex: "m",
      shiftIcon: icons.CapitalM,
      shiftLatex: "M",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Inverse,
      id: "i_inv",
      latex: "{\\placeholder}^{-1}",
      text: "Inverse",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.DoubleBond,
      id: "double_bond",
      latex: "=",
      text: "Double bond",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
  ],

  // these buttons will be present for all the tabs
  commonChildren: [
    {
      icon: icons.Addition,
      id: "plus",
      latex: "+",
      text: "Plus",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.NumberOne,
      id: "1",
      latex: "1",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.NumberTwo,
      id: "2",
      latex: "2",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.NumberThree,
      id: "3",
      latex: "3",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.Clear,
      id: "backspace",
      onClick: mfe => mfe.executeCommand("deleteBackward"),
      text: "Backspace",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.Subtraction,
      id: "minus",
      latex: "-",
      text: "Minus",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.NumberFour,
      id: "4",
      latex: "4",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.NumberFive,
      id: "5",
      latex: "5",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.NumberSix,
      id: "6",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
      latex: "6",
    },
    {
      icon: icons.ReplyArrow1Small,
      id: "undo",
      onClick: mfe => mfe.executeCommand("undo"),
      text: "Undo",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Multiplication,
      id: "multiply",
      latex: "\\times",
      text: "Multiply",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.NumberSeven,
      id: "7",
      latex: "7",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.NumberEight,
      id: "8",
      latex: "8",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.NumberNine,
      id: "9",
      latex: "9",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.ReplyArrow2Small,
      id: "redo",
      onClick: mfe => mfe.executeCommand("redo"),
      text: "Redo",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Division,
      id: "divide",
      latex: "\\div",
      text: "Divide",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.NumberZero,
      id: "0",
      latex: "0",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.Comma,
      id: "comma",
      latex: ",",
      text: "Comma",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      id: "insert",
      style: {
        gridColumn: "span 2",
        height: "44px",
      },
      text: "enter",
      variant: "progressive",
    },
    {
      icon: icons.Decimal,
      id: "decimal",
      latex: ".",
      text: "Decimal",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-default",
    },
    {
      icon: icons.Ans,
      id: "ans",
      // latex: "ans",
      text: "Decimal",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Exponent,
      id: "e^x",
      latex: "\\exponentialE^{\\placeholder{⬚}}",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Abs,
      id: "abs",
      latex: "\\operatorname{abs}\\left(\\placeholder{⬚}\\right)",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Round,
      id: "round",
      latex: "\\operatorname{round}\\left(\\placeholder{⬚}\\right)",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Mean,
      id: "mean",
      latex:
        "\\operatorname{mean}\\left(\\left[\\placeholder{⬚}\\right]\\right)",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      icon: icons.Stdev,
      id: "stdev",
      // latex: "\\mathrm{StandardDeviation}(\\left\\lbrack1,2,3\\right\\rbrack)",
      latex:
        "\\mathrm{stdev}(\\left\\lbrack\\placeholder{⬚},\\placeholder{⬚}\\right\\rbrack)",
      variant: "neutral",
      type: "plain",
      _legacy_variant: "plain-subtle",
    },
    {
      // icon: icons.Stdev,
      id: "stdevp",
      // latex: "\\mathrm{StandardDeviation}(\\left\\lbrack1,2,3\\right\\rbrack)",

      style: {
        background: "#ffffff00",
      },
    },
  ],
};
